"use strict";
exports.__esModule = true;
exports.POLICY_TYPES = void 0;
exports.POLICY_TYPES = [
    'PROPERTY_SALES_AGREEMENT',
    'PROPERTY_VOUCHER',
    'PROPERTY_CONFIRMATION_FORM',
    'CANCELLATION_CONDITIONS',
    'RECEIPT',
    'SALE_CONTRACT',
    'KVKK',
];
//# sourceMappingURL=policy-types.constants.js.map